import AbstractComponent from "./abstract-component";

const createTemplate = () => {
  return (
    `<div class="banner__wrap container swiper">
      <ul class="banner__list swiper-wrapper"></ul>
    </div>`
  );
};

export default class BannerListComponent extends AbstractComponent {
  // constructor({title = ``}) {
  //   super();

  //   this._title = title;
  // }

  getTemplate() {
    return createTemplate();
  }
}
